module.exports = __webpack_public_path__ + "img/login-bg-3.fa1ec189.jpg";